import React from 'react';
import { Button } from '@mui/material';
import styles from '../styles.module.scss';
import { CaseType } from '@brands/services/cases/types/ICase';

type Props = {
  visible: boolean;
  caseType: CaseType;
};

const SubmitActions = ({ visible, caseType }: Props): JSX.Element | null => {
  if (!visible) return null;

  return (
    <div className={styles.consultationPageRightSideSubmit}>
      <Button className={styles.consultationPageRightSideSubmitBtn} variant="contained" type="submit">
        {caseType === CaseType.oral_health_coaching || caseType === CaseType.care_coordination
          ? 'Send to patient'
          : 'Review and send to patient'}
      </Button>
    </div>
  );
};

export default SubmitActions;
